<template>
  <div>
    <el-alert
      title="确认后按未生成的明细创建生产工单草稿，并绑定该产品已受理工艺。选产品时按交期取有效价目回填单价。删除对应草稿工单后，该行可以重新生成。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.masterOrderCode" clearable placeholder="订单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.customerName" clearable placeholder="客户" style="width:150px" @keyup.enter.native="search" />
      <el-select v-model="query.orderState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
        <el-option label="部分生成" value="02" />
        <el-option label="已关闭" value="03" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="masterOrderCode" label="订单号" width="180" />
      <el-table-column prop="masterOrderName" label="名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="customerName" label="客户" width="140" show-overflow-tooltip />
      <el-table-column prop="salesPlanNumber" label="销售计划" width="120" show-overflow-tooltip />
      <el-table-column prop="deadline" label="交期" width="120" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.orderState)">{{ stateLabel(row.orderState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="340" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewRow(row.masterOrderId)">查看</el-button>
          <el-button type="text" :disabled="row.orderState !== '00'" @click="openEdit(row.masterOrderId)">修改</el-button>
          <el-button type="text" :disabled="row.orderState !== '00'" @click="confirmRow(row.masterOrderId)">确认</el-button>
          <el-button type="text" :disabled="row.orderState !== '01'" @click="unconfirmRow(row.masterOrderId)">反确认</el-button>
          <el-button type="text" :disabled="row.orderState !== '01' && row.orderState !== '02'" @click="genRow(row.masterOrderId)">生成工单</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.orderState !== '00'" @click="onDelete(row.masterOrderId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.masterOrderId ? '修改主订单' : '新增主订单'" :visible.sync="visible" width="1100px" :close-on-click-modal="false" destroy-on-close>
      <el-form :model="form" label-width="100px">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="订单号"><el-input v-model="form.masterOrderCode" placeholder="留空自动生成" :disabled="!isDraft" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="名称"><el-input v-model="form.masterOrderName" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customerId" filterable clearable placeholder="请选择客户" style="width:100%" @change="onCustomerChange">
                <el-option v-for="c in companies" :key="c.companyId" :label="(c.companyNumber ? c.companyNumber + ' / ' : '') + c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交期">
              <el-date-picker v-model="form.deadline" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="销售计划号"><el-input v-model="form.salesPlanNumber" placeholder="可选" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="销售计划名"><el-input v-model="form.salesPlanName" placeholder="可选" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <div style="margin:8px 0">
          <el-button type="primary" size="mini" :disabled="!isDraft" @click="openProductPicker">从产品库添加</el-button>
          <span style="margin-left:10px;color:#909399;font-size:12px">草稿可改数量、单价、币种和交期；已确认后明细不可改，可继续生成尚未生成的行</span>
        </div>
        <el-table :key="'mo-lines-' + (form.masterOrderId || 'new') + '-' + (form.orderState || '00')" :data="form.lineList" border size="small">
          <el-table-column prop="productNumber" label="产品编码" width="140" show-overflow-tooltip />
          <el-table-column prop="productName" label="产品名称" min-width="160" show-overflow-tooltip />
          <el-table-column label="订购量" width="150">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.orderedQty" :min="0.0001" :precision="4" :disabled="!isDraft" style="width:100%" @change="recalc(row)" />
            </template>
          </el-table-column>
          <el-table-column label="单价" width="140">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.unitPrice" :min="0" :precision="4" :disabled="!isDraft" style="width:100%" @change="recalc(row)" />
            </template>
          </el-table-column>
          <el-table-column label="币种" width="130">
            <template slot-scope="{ row }">
              <el-select v-model="row.currency" filterable :disabled="!isDraft" placeholder="币种" style="width:100%">
                <el-option v-for="item in currencies" :key="item.dictValue || item.id" :label="item.dictLabel" :value="item.dictValue" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="行金额" width="110" align="right">
            <template slot-scope="{ row }">{{ formatAmt(row.lineAmount) }}</template>
          </el-table-column>
          <el-table-column label="行交期" width="160">
            <template slot-scope="{ row }">
              <el-date-picker v-model="row.deadline" type="date" value-format="yyyy-MM-dd" :disabled="!isDraft" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" :disabled="!isDraft" @click="form.lineList.splice($index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:10px;text-align:right;font-weight:600">合计金额：{{ totalAmount }}</div>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'主订单 ' + (detail.masterOrderCode || '')" :visible.sync="detailVisible" width="900px">
      <p>客户：{{ detail.customerName || '-' }}　交期：{{ detail.deadline || '-' }}　状态：{{ stateLabel(detail.orderState) }}</p>
      <el-table :data="detail.lineList || []" border size="small">
        <el-table-column type="index" width="50" />
        <el-table-column prop="productNumber" label="产品编码" width="140" />
        <el-table-column prop="productName" label="产品名称" min-width="140" />
        <el-table-column prop="orderedQty" label="订购量" width="100" align="right" />
        <el-table-column prop="deadline" label="行交期" width="120" />
        <el-table-column prop="generatedOrderCode" label="已生成工单" width="180" />
      </el-table>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="860px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:12px">
        <el-input v-model="picker.productNumber" clearable placeholder="产品编码" style="width:180px" @keyup.enter.native="searchProductPicker" />
        <el-input v-model="picker.productName" clearable placeholder="产品名称" style="width:180px" @keyup.enter.native="searchProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="searchProductPicker">查询</el-button>
      </div>
      <el-table
        ref="productTable"
        :data="productPickerList"
        border
        row-key="productId"
        v-loading="productPickerLoading"
        height="360"
        @selection-change="productPickerSelection = $event"
      >
        <el-table-column type="selection" width="48" align="center" :reserve-selection="true" />
        <el-table-column prop="productNumber" label="产品编码" width="160" />
        <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip />
      </el-table>
      <list-pagination
        :total="pickerTotal"
        :page="pickerPage"
        :page-size="pickerPageSize"
        :page-sizes="[10, 20, 50]"
        @current-change="onPickerPage"
        @size-change="onPickerSize"
      />
      <div slot="footer">
        <el-button @click="productPickerVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProducts">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listMasterOrder, getMasterOrder, saveMasterOrder, updateMasterOrder,
  deleteMasterOrder, confirmMasterOrder, unconfirmMasterOrder, generateProductionOrders
} from '../../api/masterOrder'
import { selectCompany } from '../../api/staff'
import { listProduct } from '../../api/product'
import { effectivePrice } from '../../api/priceList'
import { listDictOptions } from '../../api/dict'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { masterOrderCode: '', customerName: '', orderState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false,
      visible: false, detailVisible: false, detail: {},
      form: {
        masterOrderId: '', masterOrderCode: '', masterOrderName: '', orderState: '00',
        customerId: '', customerName: '', salesPlanNumber: '', salesPlanName: '',
        deadline: null, remark: '', version: 0,
        lineList: []
      },
      companies: [], currencies: [],
      productPickerVisible: false,
      productPickerLoading: false,
      productPickerList: [],
      productPickerSelection: [],
      picker: { productNumber: '', productName: '' },
      pickerPage: 1,
      pickerPageSize: 10,
      pickerTotal: 0
    }
  },
  computed: {
    isDraft() {
      return !this.form.orderState || this.form.orderState === '00'
    },
    totalAmount() {
      return (this.form.lineList || []).reduce((t, l) => t + (Number(l.lineAmount) || 0), 0).toFixed(4)
    }
  },
  created() {
    this.load()
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
    listDictOptions('CURRENCY').then(res => { this.currencies = res.data || [] }).catch(() => {})
  },
  methods: {
    blank() {
      return {
        masterOrderId: '', masterOrderCode: '', masterOrderName: '', orderState: '00',
        customerId: '', customerName: '', salesPlanNumber: '', salesPlanName: '',
        deadline: null, remark: '', version: 0, lineList: []
      }
    },
    stateLabel(s) { return { '00': '草稿', '01': '已确认', '02': '部分生成', '03': '已关闭' }[s] || s || '' },
    stateType(s) { return { '00': 'info', '01': '', '02': 'warning', '03': 'success' }[s] || 'info' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMasterOrder({
        currentPage: this.page, pageSize: this.pageSize,
        masterOrderCode: this.query.masterOrderCode,
        customerName: this.query.customerName,
        orderState: this.query.orderState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    onCustomerChange(id) {
      const c = this.companies.find(i => i.companyId === id)
      this.form.customerName = c ? c.companyName : ''
    },
    openProductPicker() {
      this.picker = { productNumber: '', productName: '' }
      this.pickerPage = 1
      this.productPickerSelection = []
      this.productPickerVisible = true
      this.$nextTick(() => {
        if (this.$refs.productTable) this.$refs.productTable.clearSelection()
      })
      this.loadProductPicker()
    },
    searchProductPicker() {
      this.pickerPage = 1
      this.loadProductPicker()
    },
    onPickerPage(p) {
      this.pickerPage = p
      this.loadProductPicker()
    },
    onPickerSize(s) {
      this.pickerPageSize = s
      this.pickerPage = 1
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({
        currentPage: this.pickerPage,
        pageSize: this.pickerPageSize,
        productNumber: this.picker.productNumber,
        productName: this.picker.productName,
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.productPickerList = body.list || []
        this.pickerTotal = body.totalCount || 0
      }).finally(() => { this.productPickerLoading = false })
    },
    confirmProducts() {
      const rows = this.productPickerSelection || []
      if (!rows.length) {
        this.$message.warning('请选择产品')
        return
      }
      if (!this.form.lineList) this.form.lineList = []
      rows.forEach(p => {
        if (!p || !p.productId) return
        const line = {
          productId: p.productId,
          productNumber: p.productNumber,
          productName: p.productName,
          orderedQty: 1,
          unitPrice: 0,
          currency: 'CNY',
          priceListId: null,
          lineAmount: 0,
          deadline: this.form.deadline || null
        }
        this.form.lineList.push(line)
        this.fillPrice(line)
      })
      this.productPickerVisible = false
    },
    fillPrice(row) {
      if (!row.productId) {
        row.unitPrice = null
        row.priceListId = null
        this.recalc(row)
        return
      }
      effectivePrice(row.productId, this.form.deadline || undefined).then(res => {
        const price = res.data
        if (price && price.unitPrice != null) {
          row.unitPrice = Number(price.unitPrice)
          row.currency = price.currency || row.currency || 'CNY'
          row.priceListId = price.priceId || price.priceListId || null
        } else {
          row.unitPrice = row.unitPrice == null ? 0 : row.unitPrice
          row.priceListId = null
        }
        this.recalc(row)
      }).catch(() => {
        row.unitPrice = row.unitPrice == null ? 0 : row.unitPrice
        row.priceListId = null
        this.recalc(row)
      })
    },
    recalc(line) {
      const q = Number(line.orderedQty) || 0
      const p = Number(line.unitPrice)
      line.lineAmount = isNaN(p) ? null : p * q
    },
    formatAmt(v) {
      if (v == null || v === '') return '-'
      return Number(v).toFixed(4)
    },
    openEdit(id) {
      if (!id) {
        this.form = this.blank()
        this.visible = true
        return
      }
      getMasterOrder(id).then(res => {
        const d = res.data || {}
        this.form = {
          masterOrderId: d.masterOrderId,
          masterOrderCode: d.masterOrderCode,
          masterOrderName: d.masterOrderName,
          orderState: d.orderState,
          customerId: d.customerId || '',
          customerName: d.customerName || '',
          salesPlanNumber: d.salesPlanNumber || '',
          salesPlanName: d.salesPlanName || '',
          deadline: d.deadline || null,
          remark: d.remark,
          version: d.version,
          lineList: (d.lineList && d.lineList.length) ? d.lineList.map(l => ({
            productId: l.productId,
            productNumber: l.productNumber,
            productName: l.productName,
            orderedQty: Number(l.orderedQty),
            unitPrice: l.unitPrice == null ? 0 : Number(l.unitPrice),
            currency: l.currency || 'CNY',
            priceListId: l.priceListId || null,
            lineAmount: l.lineAmount == null ? 0 : Number(l.lineAmount),
            deadline: l.deadline || null
          })) : []
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.customerId) { this.$message.warning('请选择客户'); return }
      this.onCustomerChange(this.form.customerId)
      const lines = (this.form.lineList || []).filter(l => l.productId && Number(l.orderedQty) > 0)
      if (!lines.length) { this.$message.warning('请添加订单明细'); return }
      lines.forEach(l => this.recalc(l))
      this.saving = true
      const payload = { ...this.form, lineList: lines }
      const req = this.form.masterOrderId ? updateMasterOrder(payload) : saveMasterOrder(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    viewRow(id) {
      getMasterOrder(id).then(res => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    confirmRow(id) {
      this.$confirm('确认主订单?', '提示', { type: 'warning' }).then(() => {
        confirmMasterOrder(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    unconfirmRow(id) {
      this.$confirm('反确认后将退回草稿，可修改或删除；已生成生产工单的订单不能反确认。', '提示', { type: 'warning' }).then(() => {
        unconfirmMasterOrder(id).then(() => { this.$message.success('已反确认'); this.load() })
      }).catch(() => {})
    },
    genRow(id) {
      this.$confirm('为未生成行创建生产工单?', '提示', { type: 'warning' }).then(() => {
        generateProductionOrders(id).then(res => {
          this.$message.success('已生成 ' + ((res.data || {}).count || 0) + ' 张工单')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteMasterOrder([id]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
